/* eslint-disable react/prop-types */
import React from "react";
import ErrorBoundary from "../../components/errorBoundary/errorBoundary";
import NavbarBottom from "./NavbarBottom";

const Navbar = (props) => {
  let {
    params: { id, short_url, isAdmin, permissions, singleSite, chaseIqEnabled },
    hideTitle,
    notifications
  } = props;

  return (
    <ErrorBoundary moduleName="NavbarBottom" {...notifications}>
      <NavbarBottom
        id={id}
        short_url={short_url}
        hideTitle={hideTitle}
        hasAIAccess={chaseIqEnabled && (isAdmin || permissions.includes("dashboard_chase_iq")) && singleSite}
      />
    </ErrorBoundary>
  );
};

export default Navbar;
